export const PASSWORD_ERROR_KEYS = {
    minLength: "password.minLength",
    uppercase: "password.uppercase",
    number: "password.number",
    special: "password.special",
};

export const getPasswordValidationErrors = (password) => {
    const errors = [];

    if (password.length < 8) {
        errors.push(PASSWORD_ERROR_KEYS.minLength);
    }

    if (!/[A-Z]/.test(password)) {
        errors.push(PASSWORD_ERROR_KEYS.uppercase);
    }

    if (!/[0-9]/.test(password)) {
        errors.push(PASSWORD_ERROR_KEYS.number);
    }

    if (!/[^a-zA-Z0-9]/.test(password)) {
        errors.push(PASSWORD_ERROR_KEYS.special);
    }

    return errors;
};
